// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e34e0fe7","206":"b36006b4","214":"7e0a7fa4","488":"eda7cc5f","624":"1c90239d","654":"92f32d6f","787":"cda612ba","960":"fedd4e1a","974":"b3f8cab1"}[chunkId] + ".chunk.js";
};